"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_if_1 = require("react-if");
const utils_1 = require("../utils");
const reactstrap_1 = require("reactstrap");
exports.OsmosysSmallContainer = (_a) => {
    var { children, maxWidth = 460, header, subheader, description, card } = _a, props = tslib_1.__rest(_a, ["children", "maxWidth", "header", "subheader", "description", "card"]);
    const InnerContainer = card ? reactstrap_1.Card : utils_1.OsmosysDiv;
    return (react_1.default.createElement(utils_1.OsmosysDiv, { flexRowCenteredFilled: true },
        react_1.default.createElement(utils_1.OsmosysDiv, Object.assign({ style: { maxWidth: maxWidth === -1 ? undefined : maxWidth }, flexColCenteredFilled: true, maxWidth: maxWidth }, props),
            react_1.default.createElement(utils_1.OsmosysDiv, null,
                react_1.default.createElement(InnerContainer, { body: card ? true : undefined },
                    react_1.default.createElement(react_if_1.When, { condition: !!header },
                        react_1.default.createElement("h3", { className: "mb-3 font-weight-bold" }, header)),
                    react_1.default.createElement(react_if_1.When, { condition: !!subheader },
                        react_1.default.createElement("p", { className: "lead mb-3" }, subheader)),
                    react_1.default.createElement(react_if_1.When, { condition: !!description },
                        react_1.default.createElement("p", { className: "text-center" }, description)),
                    children)))));
};
//# sourceMappingURL=OsmosysSmallContainer.js.map